const axios = require('axios');

const API_URL = 'https://haorich.tw/agents/register';

async function register(data) {
  try {
    const results = await axios.post(API_URL, {
      data,
    });
    console.log(results);
    return results;
  } catch (e) {
    console.log(e);
    return e;
  }
}

async function geetUserInfo() {
  return '';
}

export {
  register,
  geetUserInfo,
};



// WEBPACK FOOTER //
// ./src/service/user_service.js